/**
 * Single source of truth for the three offer states from the mockup:
 *  - create            : everything editable, "Create offer"
 *  - editing (0 books) : structural fields locked, name + values editable, "Save changes"
 *  - locked (≥1 book)  : everything locked, "Locked" (deactivate from the list)
 *
 * Applies identically to Early Bird and Surge rules (direction is irrelevant
 * to locking). The backend `edit_state` wins when present: an expired offer
 * is locked even with zero bookings.
 */
export const EDIT_STATE_LOCKED = "locked";

export const getOfferLockState = ({
  isEdit = false,
  bookingCount = 0,
  editState = null,
} = {}) => {
  const isLocked =
    (isEdit && bookingCount > 0) || (isEdit && editState === EDIT_STATE_LOCKED);
  return {
    isLocked,
    // Structural = offering / trigger / units / add-remove / copy (locked as
    // soon as an offer exists, even with 0 bookings).
    structuralDisabled: isEdit,
    // Values + name (locked only once bookings exist).
    valuesDisabled: isLocked,
    nameDisabled: isLocked,
    primaryLabel: isLocked
      ? "Locked"
      : isEdit
      ? "Save changes"
      : "Create offer",
  };
};
